/* import __COLOCATED_TEMPLATE__ from './target.hbs'; */
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@ember/component';
import { inject as service } from '@ember/service';
import { action, set, computed } from '@ember/object';
import { Currency, Money } from '@square/dashboard-protos/models/squareup/connect/v2/common/money';
import { Validation } from '@banking/ui/utils/validation';
import formatMoney from '@banking/ui/utils/format-money';
let Target = (_dec = computed('accountId', 'foldersAccounts.openFoldersAccounts', 'savingsAccounts.savingsBankAccounts'), _dec2 = computed('automationSubaccountState.targetAmount.amount', 'currentBalance.amount'), _dec3 = computed('userInfo.currencyCode'), _dec4 = computed('automationSubaccountState.maxTargetAmount', 'currency'), _class = class Target extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _initializerDefineProperty(this, "automationSubaccountState", _descriptor, this);
    _initializerDefineProperty(this, "foldersAccounts", _descriptor2, this);
    _initializerDefineProperty(this, "savingsAccounts", _descriptor3, this);
    _initializerDefineProperty(this, "intl", _descriptor4, this);
    _initializerDefineProperty(this, "formatter", _descriptor5, this);
    _initializerDefineProperty(this, "userInfo", _descriptor6, this);
    _defineProperty(this, "accountId", void 0);
    _defineProperty(this, "continue", void 0);
    _defineProperty(this, "skip", void 0);
    _defineProperty(this, "validation", void 0);
    _defineProperty(this, "showValidation", false);
  }
  get currentBalance() {
    const currentAccount = [...this.savingsAccounts.savingsBankAccounts, ...this.foldersAccounts.openFoldersAccounts].find(account => account.id === this.accountId);
    if (!currentAccount) {
      // onboarding-app will not have any accounts fetched
      // and doesn't need currentBalance
      return undefined;
    }
    return currentAccount.totalAndPendingBalance;
  }
  get isTargetLessThanBalance() {
    if (this.automationSubaccountState.targetAmount === undefined || this.automationSubaccountState.targetAmount === null || this.currentBalance === undefined) {
      return false;
    }
    return this.automationSubaccountState.targetAmount.amount < this.currentBalance.amount;
  }
  get currency() {
    return Currency[this.userInfo.currencyCode];
  }
  get maxTarget() {
    return new Money.Builder().amount(this.automationSubaccountState.maxTargetAmount).currency(this.currency).build();
  }
  validate() {
    let validation = new Validation();
    if (!this.automationSubaccountState.targetAmount) {
      validation = new Validation(this.intl.t('banking.savings.automation.create.target.noTargetError'));
    }
    if (this.automationSubaccountState?.targetAmount && this.automationSubaccountState.targetAmount.amount > this.automationSubaccountState.maxTargetAmount) {
      validation = new Validation(this.intl.t('banking.savings.automation.create.target.aboveTargetError', {
        maxTarget: formatMoney(this.maxTarget, this.formatter),
        htmlSafe: true
      }));
    }
    if (this.currentBalance && this.isTargetLessThanBalance) {
      validation = new Validation(this.intl.t('banking.savings.automation.create.target.balanceError', {
        currentBalance: formatMoney(this.currentBalance, this.formatter),
        htmlSafe: true
      }));
    }
    set(this, 'validation', validation);
  }
  updateTarget(value) {
    set(this.automationSubaccountState, 'targetAmount', value);
    this.validate();
  }
  _continue() {
    set(this, 'showValidation', true);
    this.validate();
    if (this.validation?.isValid) {
      this.continue();
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "automationSubaccountState", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "foldersAccounts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "savingsAccounts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "formatter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "currentBalance", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "currentBalance"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isTargetLessThanBalance", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "isTargetLessThanBalance"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currency", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "currency"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maxTarget", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "maxTarget"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "validate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "validate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateTarget", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateTarget"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_continue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_continue"), _class.prototype), _class);
export { Target as default };